import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { LoginPage } from '../../pages/login';
import { SearchPage } from '../../pages/search';
import { GroupedTasksPage, TaskCommentPage, TaskPage, TasksPage } from '../../pages/tasks';
import { PrivateRoute } from '../../shared/ui/PrivateRoute';
import { rootRoutes } from './rootRoutes';

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={rootRoutes.login} element={<LoginPage />} />
        <Route element={<PrivateRoute />}>
          <Route path={rootRoutes.search} element={<SearchPage />} />
          <Route path={rootRoutes.task} element={<TaskPage />} />
          <Route path={rootRoutes.allTaskList} element={<TasksPage />} />
          <Route path={rootRoutes.filteredTaskList} element={<TasksPage />} />
          <Route path={rootRoutes.groupedTaskList} element={<GroupedTasksPage />} />
          <Route path={rootRoutes.taskComment} element={<TaskCommentPage />} />
          <Route path={rootRoutes.taskComment} element={<TaskCommentPage />} />
          <Route path="*" element={<Navigate to={rootRoutes.taskList} replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
